import styled from '@emotion/styled';

export const PhotoCard = styled.img`
  width: 150px;
  height: 150px;
`;

export const OnPhotoLoading = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
